export default "__VITE_ASSET__NrHE911M__"